import React from "react"
import ReactDOM from "react-dom"
import MaterialProviderComponent from "./material-provider-component"

export default class MaterialProviderModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<MaterialProviderComponent {...self.modelJson} lang={document.body.dataset.language} />, self.elem)
  }
}
